/* The report view's panes (website_hq/web_template/report_view, rfhq_report_view.css): on a wide board every pane is open; on a phone a pane marked data-shut is folded to its title and one line and opens when
   tapped. The width asked is the report's own (it sits in a column that may be narrower than the screen). Without this script every pane is open. Nothing here has any wording or colour. */
(function () {
	"use strict";
	const NARROW = 760;

	function sync(root) {
		const narrow = root.getBoundingClientRect().width <= NARROW;
		root.dataset.rvNarrow = narrow ? "1" : "";
		root.querySelectorAll("details.rv-pane").forEach((pane) => {
			const mode = narrow ? "n" : "w";
			if (pane.dataset.rvMode === mode) return;
			pane.dataset.rvMode = mode;
			pane.open = !narrow || !pane.hasAttribute("data-shut");
		});
	}

	/* The bar above the panes (website_hq/report_toolbar.py says what it may hold): a day to move by and a place to choose. Drawn from data; every word in it comes from the app, and every address is a path on this site.
	   The place control is the shared one (rfhq_lookup.js). */
	const { icon, withArg } = window.rfhqUI || {};

	function dateControl(c, UI) {
		const { h, localPath } = UI;
		const words = c.labels || {};
		const step = (href, mark, label) => (href && localPath(href)) ? h("a", { class: "rv-ctl-btn rv-ctl-step", href: localPath(href), "aria-label": label || "", text: mark }) : h("span", { class: "rv-ctl-btn rv-ctl-step is-off", "aria-hidden": "true", text: mark });
		const input = h("input", { type: "date", class: "rv-ctl-date", value: c.value, min: c.min, max: c.max, "aria-label": words.pick || "" });
		input.addEventListener("change", () => { if (input.value) window.location.assign(withArg(c.arg, input.value)); });
		const shown = c.label || c.value;
		const pick = h("button", { type: "button", class: "rv-ctl-btn rv-ctl-pick", "aria-label": (words.pick ? words.pick + ": " : "") + shown }, icon("date"), h("span", { text: shown }));
		const group = h("div", { class: "rv-ctl-group" }, step(c.previous, "\u2039", words.previous), h("span", { class: "rv-ctl-pickwrap" }, pick, input), step(c.next, "\u203a", words.next));
		// The calendar is the browser's own, opened by the button (the date box stays out of the way); an old browser that cannot open it from a button shows the date box itself.
		const native = () => { group.classList.add("rv-ctl-native"); input.removeAttribute("tabindex"); input.removeAttribute("aria-hidden"); };
		if (typeof input.showPicker === "function") { input.setAttribute("tabindex", "-1"); input.setAttribute("aria-hidden", "true"); } else native();
		pick.addEventListener("click", () => { try { input.showPicker(); } catch (e) { native(); input.focus(); } });
		if (c.today && localPath(c.today) && words.today) group.append(h("a", { class: "rv-ctl-btn rv-ctl-today", href: localPath(c.today), text: words.today }));
		return group;
	}

	function bar(root) {
		let spec = null;
		try { spec = JSON.parse(root.dataset.bar || "null"); } catch (e) { spec = null; }
		const UI = window.rfhqUI;
		if (!spec || !Array.isArray(spec.controls) || !spec.controls.length || !UI || root.querySelector(":scope > .rv-ctl")) return;
		const parts = spec.controls.map((c) => (c.type === "date" ? dateControl(c, UI) : c.type === "lookup" && UI.lookupControl ? UI.lookupControl(c, UI) : null)).filter(Boolean);
		if (parts.length) root.prepend(UI.h("div", { class: "rv-ctl" }, parts));
	}

	function mount(root) {
		if (root.dataset.rvMounted) return;
		root.dataset.rvMounted = "1";
		bar(root);
		sync(root);
		if (window.ResizeObserver) new ResizeObserver(() => sync(root)).observe(root);
		root.addEventListener("toggle", (event) => {  // on a wide board a pane is never folded
			const pane = event.target;
			if (!root.dataset.rvNarrow && pane.matches && pane.matches("details.rv-pane") && !pane.open) pane.open = true;
		}, true);
	}

	function sweep(scope) { (scope || document).querySelectorAll(".rfhq-rv").forEach(mount); }

	window.addEventListener("beforeprint", () => document.querySelectorAll("details.rv-pane").forEach((pane) => { pane.dataset.rvWas = pane.open ? "1" : ""; pane.open = true; }));
	window.addEventListener("afterprint", () => document.querySelectorAll("details.rv-pane").forEach((pane) => { pane.open = !!pane.dataset.rvWas; }));
	if (window.rfhqDom) window.rfhqDom.onAdded((roots) => roots.forEach((node) => { if (node.matches && node.matches(".rfhq-rv")) mount(node); else sweep(node); }));
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => sweep()); else sweep();
})();
